export const INFO_MESSAGES = {
  whitePapersDownloadStarted: 'whitePapersDownloadStarted',
};
